/*
 * Farida Gupta - one-time reveal animation for the "dummy product media" placeholder shown on
 * mobile product pages (theme/snippets/product-gallery.liquid, .dummy-prodcut-media-wrapper).
 * It sits above the real gallery (z-index: 2, see main-product.css) so on first visit it plays
 * the CSS sway animation (main-product.css @keyframes dummy-product-media-sway), then fades out
 * and stays hidden, revealing the real gallery underneath. The "seen" flag is stored in
 * localStorage (theme:dummy-product-media-seen), following the same "theme:" storage convention
 * used elsewhere in the theme (theme.js's NewsletterPopup, theme:recently-viewed-products) -
 * clearing site data/local storage makes the animation play again on the next load.
 */
const STORAGE_KEY = 'theme:dummy-product-media-seen';

document.querySelectorAll('.dummy-prodcut-media-wrapper').forEach((wrapper) => {
  let hasSeen = false;

  try {
    hasSeen = localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    // Safari private mode / storage disabled - fall back to always animating.
  }

  if (hasSeen) {
    wrapper.classList.add('is-dismissed');
    return;
  }

  wrapper.classList.add('is-animating');

  wrapper.addEventListener(
    'animationend',
    () => {
      wrapper.classList.remove('is-animating');
      wrapper.classList.add('is-dismissed');

      try {
        localStorage.setItem(STORAGE_KEY, 'true');
      } catch (e) {
        // Ignore - the animation simply replays next visit if storage is unavailable.
      }
    },
    { once: true }
  );
});
